import { BsExclamationTriangleFill } from "react-icons/bs";
import { Accordion } from "cdhs-ui-library";
import styles from "../Question/question.module.scss";
import { useTranslations } from "../../contexts/LanguageContext";



export interface QuestionDisplayProps {
    order?: number,
    description?: string,
    notes?: string,
    errorMessage?: string | null,
    siblingIndex?: string
}

function QuestionDisplay(props: QuestionDisplayProps) {
    const t = useTranslations()
    return (
      <>
    <p>
        {props.order}.{props.siblingIndex ?? ""} {props.description}
        {props.errorMessage && <span className={styles.errorText}>*</span>}
      </p>
      {props.errorMessage && (
        <div className={styles.error}>
          <p className={styles.errorText}>
            <span>
              <BsExclamationTriangleFill />
            </span>{" "}
            {props.errorMessage}
          </p>
        </div>
      )}
      {(props.notes && props.notes?.length > 1) && (
        <Accordion variant="NYTD" title={t("questionDisplay_accordion", "More info")} content={props.notes} />
      )}
    </>
  )
}

export default QuestionDisplay